import { render, staticRenderFns } from "./CreateWorkerCards.vue?vue&type=template&id=5e116d10"
import script from "./CreateWorkerCards.vue?vue&type=script&lang=js"
export * from "./CreateWorkerCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports